/* eslint-disable react/prop-types */
// @ts-nocheck
import IconButton from '@material-ui/core/IconButton';
import { SettingsOutlined, FilterList, ExpandMore, ExpandLess } from '@material-ui/icons';
import DownloadIcon from '@material-ui/icons/CloudDownload';
import InfoIcon from '@material-ui/icons/HelpOutline';
import Refresh from '@material-ui/icons/Refresh';
import { Entity } from '@sketchpixy/rubix/lib/L20n';
import React, { Component } from 'react';
import { GREEN } from '../../_config/consts.js';
import withBreakpoint from '../../_hoc/withBreakpoint.jsx';
import CloudUploadIconCustom from '../CustomIcons/CloudUploadIconCustom.jsx';
import SimpleExportMenu from '../ExportMenus/SimpleExportMenu.jsx';
import MDButton from '../MDButton/MDButton.jsx';
import SearchBarForm from '../forms/SearchBarForm.jsx';


class PresentationalViewHeader extends Component {

  constructor(props) {
    super(props);
    this.state = { filtersOpen: false };
  }

  render() {
    const {
      themeName,
      onFilterChange,
      onSearchSubmit,
      onNewEntity,
      newEntityTitle,
      onSelectGuest,
      onSelectGuestTag,
      onRefresh,
      searchPlaceholderEntityName,
      onSelectLockTag,
      onSearchReset,
      onSelectOption,
      selectableFieldName,
      selectableOptions,
      selectableFieldTitle,
      onSelectOption2,
      selectableFieldName2,
      selectableOptions2,
      selectableFieldTitle2,
      onExportCSV,
      isGuestTagsMultiSelectionActive,
      isLockTagsMultiSelectionActive,
      onGuestCompanyNameChange,
      onNotesSearchChange,
      onUserCommunicationSearchChange,
      onInfo,
      searchNameContainerStyle,
      searchGuestContainerStyle,
      entitiesNumberSection,
      onExportElements,
      numberOfElements,
      isCardMappingEnabled,
      cardIdsMap,
      onSelectOriginalCard,
      onImportFromCSV,
      customFields,
      onCustomFieldSearch,
      onSelectLockHasGateway,
      onSelectProfile,
      onSelectPriority,
      priorityOptions,
      onSelectCategory,
      categoryOptions,
      onSelectAssignee,
      assigneeOptions,
      onSelectResourceType,
      resourceTypeOptions,
      onDatesChange,
      startDate,
      endDate,
      datesHelpersOptions,
      mainFilterTextFormattingFunction,
      onSettings,
      containerStyle,
      additionalThemeClass,
      exportIconStyle,
      exportTitleStyle,
      searchCodePlaceholderEntityName,
      onCodeSearchChange,
      infoIconStyle,
      resetButtonContainerStyle,
      onSelectCheckbox,
      checkboxLabelEntityName,
    } = this.props;
    const themeClass = `list-view-header bg-${themeName}-theme ${additionalThemeClass||""}`;
    const { breakpoint } = this.props;
    const isPhone = breakpoint && breakpoint.isPhone;
    const { filtersOpen } = this.state;
    const hasSearchFilters = Boolean(
      onFilterChange || onSearchSubmit || onSelectGuest || onSelectGuestTag ||
      onSelectLockTag || onSelectOption || onSelectOption2 || onSelectProfile ||
      onSelectPriority || onSelectCategory || onSelectAssignee || onSelectResourceType ||
      onDatesChange || onSelectLockHasGateway || onSelectCheckbox ||
      onCodeSearchChange || onGuestCompanyNameChange || onNotesSearchChange || onUserCommunicationSearchChange ||
      onSelectOriginalCard || (customFields && customFields.length)
    );
    // Su smartphone i filtri sono collassabili per non occupare spazio.
    const showFilters = !isPhone || filtersOpen;
    return (
      <div className={themeClass} style={{ width: '100%', ...containerStyle }}>
        {isPhone ? (
          <div
            className="r-filters-toggle"
            onClick={() => this.setState({ filtersOpen: !filtersOpen })}
            style={{ width: '100%', display: 'flex', alignItems: 'center', cursor: 'pointer', padding: '10px 4px' }}
          >
            <FilterList style={{ color: 'white', marginRight: 8 }} />
            <h4 style={{ color: 'white', fontWeight: 'bold', margin: 0, flex: 1 }}><Entity entity="searchFilters" /></h4>
            {filtersOpen ? <ExpandLess style={{ color: 'white' }} /> : <ExpandMore style={{ color: 'white' }} />}
          </div>
        ) : null}
        {showFilters ? (
        <>
        <div className="r-list-view-header-row" style={{ padding: 0, display: 'flex', marginLeft: 0, alignItems: 'center', flexWrap: 'wrap', rowGap: 8, columnGap: 8, width: '100%' }}>
          {entitiesNumberSection}
          {hasSearchFilters ? (
          <SearchBarForm
            onSelectCheckbox={onSelectCheckbox ? value => onSelectCheckbox(value) : null}
            checkboxLabelEntityName={checkboxLabelEntityName}
            customFields={customFields}
            resetButtonContainerStyle={resetButtonContainerStyle}
            isGuestTagsMultiSelectionActive={isGuestTagsMultiSelectionActive}
            isLockTagsMultiSelectionActive={isLockTagsMultiSelectionActive}
            searchPlaceholderEntityName={searchPlaceholderEntityName}
            searchCodePlaceholderEntityName={searchCodePlaceholderEntityName}
            onSubmit={onSearchSubmit ? data => onSearchSubmit(data) : () => {}}
            onSearchSubmit={onSearchSubmit ? data => onSearchSubmit(data) : null}
            onFilterChange={onFilterChange ? value => onFilterChange(value) : null}
            onGuestCompanyNameChange={onGuestCompanyNameChange ? value => onGuestCompanyNameChange(value) : null}
            onNotesSearchChange={onNotesSearchChange ? value => onNotesSearchChange(value) : null}
            onCodeSearchChange={onCodeSearchChange ? value => onCodeSearchChange(value) : null}
            onUserCommunicationSearchChange={onUserCommunicationSearchChange ? value => onUserCommunicationSearchChange(value) : null}
            onSelectLockTag={onSelectLockTag ? tag => onSelectLockTag(tag) : null}
            onSelectGuestTag={onSelectGuestTag ? tag => onSelectGuestTag(tag) : null}
            onSelectLockHasGateway={onSelectLockHasGateway ? value => onSelectLockHasGateway(value) : null}
            onSelectGuest={onSelectGuest ? guest => onSelectGuest(guest) : null}
            onSearchReset={onSearchReset ? () => onSearchReset() : null}
            onSelectProfile={onSelectProfile ? (profile) => onSelectProfile(profile) : null}
            onCustomFieldSearch={onCustomFieldSearch ? (value, key, type) => onCustomFieldSearch(value, key, type) : null}
            onSelectOption={onSelectOption ? value => onSelectOption(value) : null}
            onSelectOption2={onSelectOption2 ? value => onSelectOption2(value) : null}
            onSelectPriority={onSelectPriority ? value => onSelectPriority(value) : null}
            priorityOptions={priorityOptions?priorityOptions:null}
            onSelectCategory={onSelectCategory ? value => onSelectCategory(value) : null}
            categoryOptions={categoryOptions?categoryOptions:null}
            onSelectAssignee={onSelectAssignee ? value => onSelectAssignee(value) : null}
            assigneeOptions={assigneeOptions?assigneeOptions:null}
            onSelectResourceType={onSelectResourceType ? value => onSelectResourceType(value) : null}
            resourceTypeOptions={resourceTypeOptions?resourceTypeOptions:null}
            onDatesChange={onDatesChange? (startDate, endDate) => onDatesChange(startDate, endDate) : null}
            startDate={startDate}
            endDate={endDate}
            datesHelpersOptions={datesHelpersOptions}
            selectableFieldName={selectableFieldName}
            selectableOptions={selectableOptions}
            selectableFieldTitle={selectableFieldTitle}
            selectableFieldName2={selectableFieldName2}
            selectableOptions2={selectableOptions2}
            selectableFieldTitle2={selectableFieldTitle2}
            searchNameContainerStyle={searchNameContainerStyle}
            searchGuestContainerStyle={searchGuestContainerStyle}
            mainFilterTextFormattingFunction={mainFilterTextFormattingFunction ? value => mainFilterTextFormattingFunction(value) : null}
            cardIdsMap={cardIdsMap}
            onSelectOriginalCard={isCardMappingEnabled && onSelectOriginalCard ? selectedOriginalCard => onSelectOriginalCard(selectedOriginalCard) : null}
          />
          ) : null}
          {onNewEntity &&
            <MDButton
              fullWidth={false}
              backgroundColor={GREEN}
              containerStyle={{ margin: 0, marginTop: 4, marginLeft: 10, flexShrink: 0 }}
              title={newEntityTitle && <Entity entity={newEntityTitle} />}
              onClick={() => onNewEntity()}
            />
          }
          {onImportFromCSV &&
            <MDButton
              fullWidth={false}
              backgroundColor="#0288D1"
              containerStyle={{ margin: 0, marginLeft: 20, marginTop: 4, flexShrink: 0 }}
              icon={<CloudUploadIconCustom style={{ color: 'white', marginLeft: 10, marginTop: -2, width: 20 }} />}
              title={<Entity entity="importFromCSV" />}
              onClick={() => onImportFromCSV()}
            />
          }
          {onExportCSV &&
            <MDButton
              fullWidth={false}
              backgroundColor="#0288D1"
              containerStyle={{ margin: 0, marginLeft: 20, marginTop: 4, flexShrink: 0 }}
              icon={<DownloadIcon style={{ color: 'white', marginLeft: 10, fontSize: 18 }} />}
              title="CSV"
              onClick={() => onExportCSV()}
            />
          }
          {onRefresh ? (
            <IconButton onClick={() => onRefresh()} style={{ marginLeft: 10, flexShrink: 0 }}>
              <Refresh style={{ fontSize: 30, color: 'white' }} />
            </IconButton>
          ) : null}
          {onInfo ? (
            <IconButton onClick={() => onInfo()} style={{ marginLeft: 10, flexShrink: 0 }}>
              <InfoIcon style={{ fontSize: 30, color: 'white', ...infoIconStyle }} />
            </IconButton>
          ) : null}
          {onSettings ? (
            <IconButton onClick={() => onSettings()} style={{ marginLeft: 10, flexShrink: 0 }}>
              <SettingsOutlined style={{ fontSize: 30, color: 'white' }} />
            </IconButton>
          ) : null}
          {onExportElements ? (
            <div style={{ marginLeft: 10, flexShrink: 0 }}>
              <SimpleExportMenu
                numberOfElements={numberOfElements}
                onExportLogs={format => onExportElements(format)}
                iconStyle={exportIconStyle}
                exportTitleStyle={exportTitleStyle}
              />
            </div>
          ) : null}
        </div>
        </>
        ) : null}
      </div>
    );
  }
};

export default withBreakpoint(PresentationalViewHeader);
